import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Ny {{method}}-ordre!',
        scheduled: 'Planlagt {{method}}-ordre!',
      },
      labels: {
        today: 'i dag',
        time_remaining_to_accept: 'tilbage til at acceptere',
      },
      time_tag: {
        asap: '🕓 Afhentning om {{time}}',
        scheduled: '🕓 Afhentning {{day}} kl. {{time}}',
      },
      time_tag_estimated: {
        asap: '🕓 Omtrentlig afhentningstid: {{time}}',
        scheduled: '🕓 Omtrentlig afhentningstid: {{day}} kl. {{time}}',
      },
      buttons: {
        confirm_order: 'Bekræft ordre',
        cancel_order: 'Annuller ordre',
      },
      feedback: {
        rough_estimate_warning:
          'Dette er kun et groft estimat. Du får den faktiske tilberedningstid, når en chauffør er tildelt, og leveringstiden er bekræftet. På det tidspunkt udskrives din bon automatisk.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Tilberedningstid',
      labels: {
        today: 'I dag',
        order_time: {
          delivery: {
            asap: 'Levering om',
            scheduled: 'Levering den',
          },
          other: {
            asap: 'Afhentning om',
            scheduled: 'Afhentning den',
          },
        },
        can_you_make_it: 'Kan du nå det?',
        we_also_send_this_update_to_the_customer: 'Vi sender også denne opdatering til kunden',
      },
      buttons: {
        yes_lets_go: 'Ja, kør!',
        no_change_time: 'Nej, ændr tid',
        confirm: 'Bekræft',
      },
      toasts: {
        order_confirmed: {
          title: 'Ordre #{{number}} bekræftet',
          body: 'Start ikke tilberedning endnu! Vi giver besked, når en chauffør er tildelt.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Desværre skal leveringen annulleres, fordi chaufføren ikke er tilgængelig. Klik på de tre prikker øverst til højre for at annullere ordren og refundere pengene til kunden',
        [BackendErrorCode.DeliveryProviderException]:
          'Desværre skal leveringen annulleres, fordi chaufføren ikke er tilgængelig. Klik på de tre prikker øverst til højre for at annullere ordren og refundere pengene til kunden',
      },
    },
  },
};
